module.exports = __webpack_public_path__ + "img/37.2cf7702a.jpg";